/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type PropsWithChildren, type ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	grid: {
		display: 'grid',
		gridTemplateColumns: 'auto minmax(0, 1fr)',
		columnGap: token('space.150'),
		rowGap: token('space.100'),
	},
	row: {
		display: 'contents',
	},
	value: {
		maxLines: 1,
	},
});

type RowProps = {
	label: ReactNode;
	value: ReactNode;
};

export const EntityValueGridRow = ({ label, value }: RowProps): JSX.Element => (
	<Box xcss={styles.row}>
		<Box>
			<Text color="color.text.subtlest">{label}</Text>
		</Box>
		<Box xcss={styles.value}>{value}</Box>
	</Box>
);

export const EntityValueGrid = ({ children }: PropsWithChildren): JSX.Element => (
	<Box xcss={styles.grid}>{children}</Box>
);
